import type { LevelDefinition } from '../world/LevelDefinition';

/**
 * The demo chamber: a rectangular room with every surface magnetic, a central
 * zero-G volume and drones on three different surfaces.
 */
export const TEST_CHAMBER: LevelDefinition = {
  id: 'test-chamber',
  name: 'Test Chamber',
  size: [24, 14, 10],
  surfaces: {
    floor: { enabled: true, magnetic: true },
    ceiling: { enabled: true, magnetic: true },
    left: { enabled: true, magnetic: true },
    right: { enabled: true, magnetic: true },
    front: { enabled: true, magnetic: true },
    back: { enabled: true, magnetic: true },
  },
  // The spawn looks along the chamber so the first drone is inside the
  // opening view arc rather than behind the player.
  spawn: { surface: 'floor', position: [-8, 0, 3], facing: -0.6 },
  targets: [
    { type: 'drone', surface: 'floor', position: [6, 0, -1] },
    { type: 'drone', surface: 'left', position: [-12, 6, 1.5] },
    { type: 'drone', surface: 'ceiling', position: [2, 14, 0] },
    { type: 'drone', surface: 'right', position: [12, 4, -2] },
  ],
  obstacles: [
    { type: 'box', position: [2, 1, 2.5], size: [1.6, 2, 1.6] },
    { type: 'box', position: [-4, 0.75, -3], size: [1.4, 1.5, 1.4] },
  ],
  seed: 1337,
};
